import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from '../../../../shared/models/datatables-response';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../../../../shared/auth/authentication.service';
import { environment } from '../../../../../environments/environment'
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../../../shared/providers/validation.service';
import { IPropertyDetails } from '../../../../shared/models/propertydetails';
import { PropertyListingService } from '../../../../shared/providers/property-listing.service';
import { LoaderService } from '../../../../shared/providers/loader.service';
import { ToastService } from '../../../../shared/providers/toast.service';
import { IPropertyRentTermModel } from '../../../../shared/models/PropertyRentTermModel';

enum views {
  DealList = 1,
  Offers = 2,
  Likes = 3,
  Views = 4,
  Inquiries = 5,
  OM = 6
}

@Component({
  selector: 'app-property-data-tab',
  templateUrl: './property-data.component.html'
})
export class PropertyDataComponent implements OnInit {

  constructor(private http: HttpClient, public Authentication: AuthenticationService, private activatedRoute: ActivatedRoute, private router: Router, public Validation: ValidationService,
    private _propertyService: PropertyListingService, private loaderService: LoaderService, private _toastService: ToastService ) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let fromMenu = params['fromMenu'];
      if (fromMenu !== null && fromMenu !== undefined) {
        this.currentMenu = fromMenu;
      }
    });    
  }

  propertyGuid: any;
  propertyId: number;
  property = {} as IPropertyDetails;

  dtOptions = {};
  table: DataTableDirective;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  protected readonly BASE_URL: string = environment.base_url;
  LoggedInUser: any;
  view = views;
  currentMenu = '';
  user: any;
  PropertyRentTerm: IPropertyRentTermModel[];

  Is1031 = false;
  @Input() sellerId = 0;
  @Input() parentPageId = 0;
  pageName = 'Deals';
  viewAsChild = false;
  optionsCount: number;
  characterstics: string = '';

  ngOnInit() {
    this.loaderService.display(true);   

    this.activatedRoute.params.subscribe(params => {
      if (params.id) {
        this.propertyGuid = params.id;        
      }
    });

    this.user = this.Authentication.user;
    this.loadPageContent();
   
  }


  loadPageContent() {
    this.loaderService.display(true);
    this._propertyService.getDataEntryPropertyDetails(this.propertyGuid, this.user.Id).subscribe(response => {
      if (response != null) {

        this.property = response;
        this.property.IsDEProperty = true;
        this.propertyGuid = response.Guid;

        this.propertyId = response.Id;

        if (this.property.PropertyCharacteristicsList.length > 0) {
          this.property.PropertyCharacteristicsList.forEach(item => {
            this.characterstics += item.Description + ", ";
          });
          this.characterstics = this.characterstics.slice(0, -2)
        }

        this.loadRentTerm();

        response.LeaseCommencementDate = this.Validation.convertUTCDateToLocalDate(response.LeaseCommencementDate);
        response.LeaseExpirationDate = this.Validation.convertUTCDateToLocalDate(response.LeaseExpirationDate);
        this.property.Remaining_Term = this.Validation.getRemainingTerm(response.LeaseExpirationDate, response.LeaseCommencementDate);
        this.loaderService.display(false);
      }
      else {

        this.loaderService.display(false);
        this._toastService.clearAllToast();
        this._toastService.addToast({ title: 'Property data Not Available', msg: "The property you are trying to view is not available", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
             

      }
    });
  }

  loadRentTerm() {

    this._propertyService.GetDataEntryPropertyRentTermTable(this.propertyId).subscribe(res => {
       
        if (res.length > 0) {
          for (let i = 0; i < res.length; i++) {
            res[i].LeaseStartDate = this.Validation.convertUTCDateToLocalDate(res[i].LeaseStartDate);
            res[i].LeaseEndDate = this.Validation.convertUTCDateToLocalDate(res[i].LeaseEndDate);
          }

          this.PropertyRentTerm = res;
          this.saveRentTermDetails();
        }
      });      
  }

  saveRentTermDetails() {
    this.PropertyRentTerm.forEach(item => {
      item.NetOperatingIncome = Math.round(item.NetOperatingIncome);
    });
  }

  showRentTermOptions(index) {
    var status = false;
    var count = 0;
    if (index == 0) {
      this.optionsCount = 0;
    }
    this.PropertyRentTerm.forEach(res => {
      if (res.IsOptional) {
        if (count == index && this.optionsCount == 0) {
          status = true
          this.optionsCount = 1
        }
      }
      count++;
    })
    return status;
  }

  showCurrentDate(currentitem) {
    let date = new Date();
    var status = false;
    if (currentitem.LeaseStartDate <= date && currentitem.LeaseEndDate >= date) {
      status = true;
    }

    return status;
  } 

}
